import {
    DateTime,
} from 'luxon'
import {
    defineStore,
} from 'pinia'

interface LogEntry {
    message: string
    type: 'info' | 'error'
    timestamp: DateTime
    items?: unknown[]
}

export const useLogStore = defineStore('log', () => {
    const entries = ref<LogEntry[]>([])

    function log(message: string, type: 'info' | 'error' = 'info', ...items: unknown[]): void {
        entries.value.push({
            message,
            type,
            timestamp: DateTime.now(),
            items,
        })
    }

    function info(message: string, ...items: unknown[]): void {
        log(message, 'info', ...items)
    }

    function error(message: string, ...items: unknown[]): void {
        log(message, 'error', ...items)
    }

    return {
        entries,
        log,
        info,
        error,
    }
})
